import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Collection } from '../models/ui/collection.model';
import { NearDupTextGrouping } from '../models/ui/near-dup-text-grouping.model';
import { DocSdk } from '../sdks/doc.sdk';

@Injectable({
	providedIn: 'root'
})
export class NearDupTextGroupingManager {

	constructor(private docSdk: DocSdk) { }

	public getNearDupTextGroupings(index: number, pageSize: number): Observable<Collection<NearDupTextGrouping>> {
		return this.docSdk.getNearDupTextGroupings(index, pageSize);
	}
}
